// @flow

import createReducer from 'fc-utils/createReducer'

import initialState from './reports/initialState'
import reports from './reports/reports'

export default createReducer({
  ...initialState,
}, {
  ...reports,
})
